/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Signin_IncompleteInputs */

const en_mcp_connect_signin_incomplete = /** @type {(inputs: Mcp_Connect_Signin_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in wasn’t completed. Try again or use another sign-in method.`)
};

const es_mcp_connect_signin_incomplete = /** @type {(inputs: Mcp_Connect_Signin_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se completó el inicio de sesión. Inténtalo de nuevo o usa otro método.`)
};

/**
* | output |
* | --- |
* | "Sign-in wasn’t completed. Try again or use another sign-in method." |
*
* @param {Mcp_Connect_Signin_IncompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_signin_incomplete = /** @type {((inputs?: Mcp_Connect_Signin_IncompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Signin_IncompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_signin_incomplete(inputs)
	return en_mcp_connect_signin_incomplete(inputs)
});